import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoginService } from 'src/app/service/login.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  providers: [MessageService]
})
export class AccountComponent implements OnInit {
  passwordRestore: boolean | undefined
  constructor(private loginservice:LoginService, public router: Router, private messageService: MessageService) 
  {
    this.passwordRestore = loginservice.chatCrmUser.passwordRestore
   }

  ngOnInit(): void {

  }


  updatePasswordRestore(status: boolean) {
    this.passwordRestore = status;
  }


}
